import React from 'react';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';

export default function AvtalsTyp(props) {

    const AvtalTyplist = useSelector(state => state.accountsData.AvtalTyp)

    const [avtalTyp, setavtalTyp] = React.useState(props.valueavtaltyp);
    
    React.useEffect(()=>{
        setavtalTyp(props.valueavtaltyp)
    },[props.valueavtaltyp])
    React.useEffect(()=>{
        if(!isEmpty(AvtalTyplist.filter(item=>{return parseInt(item.AvtalStanderd) === 1}))){
            props.selectedthisAvtalType(AvtalTyplist.filter(item=>{return parseInt(item.AvtalStanderd) === 1})[0].type)
        }
    },[AvtalTyplist])

    return (
        <TextField
            select
            label={<IntlMessages id="Agreement.Type"/>}
            variant="outlined"
            error={parseInt(avtalTyp)===0}
            size="small"
            fullWidth
            value={avtalTyp}
            onChange={(e) => {
                setavtalTyp(e.target.value)
                props.selectedthisAvtalType(e.target.value)
            }}
            SelectProps={{
                native: true,
            }}
        >
            <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
            {AvtalTyplist.map((option) => (
                <option key={option.id} value={option.type}>
                    {option.type}
                </option>
            ))}
        </TextField>
      );
}

